window.addEventListener('DOMContentLoaded', function () {
    let sliders = document.querySelectorAll('.promo-slider');

    if (sliders.length > 0) {
        for (let i = 0; i < sliders.length; i++) {
            let main = sliders[0].querySelector('.promo-slider__gallery .splide');
            let thumbnails = sliders[0].querySelector('.promo-slider__thumbnails .splide');

            let main_splide = new Splide(main, {
                type: 'fade',
                pagination: false,
                arrows: false,
                autoplay: true,
                interval: 5000,
                drag: 'free',
                snap: true,
            });

            let thumbnails_splide = new Splide(thumbnails, {
                type: 'loop',
                perPage: 2,
                rewind: true,
                gap: 12,
                arrows: true,
                pagination: false,
                isNavigation: true,
                fixedHeight: 140,
                cover: true,
                drag: 'free',
                snap: true,
                padding: {
                    right: 120
                },
                breakpoints: {
                    1200: {
                        fixedHeight: 100,
                    },
                    992: {
                        perPage: 4,
                    },
                    576: {
                        perPage: 2,
                    }
                }
            });
            let bar = thumbnails.querySelector('.splide__progress-bar');

            // Updates the bar width whenever the carousel moves:
            thumbnails_splide.on('mounted move drag dragging', function () {
                let end = thumbnails_splide.Components.Controller.getEnd() + 1;
                let rate = Math.min((thumbnails_splide.index + 1) / end, 1);

                bar.style.width = String(100 * rate) + '%';
            });

            main_splide.sync(thumbnails_splide);
            main_splide.mount();
            thumbnails_splide.mount();
        }
    }
});
